import React from 'react'

/* Atoms */
import Box from 'components_new/atoms/Box'
import Icon from 'components_new/atoms/Icon'
import Tooltip from 'components_new/atoms/Tooltip'

import EditableText from './EditableText'

/* Types */
import {
  InnerWidgetPatchBody,
  TCoreWidget,
  WidgetType
} from 'types/GlobalWidget'

interface WidgetHeaderProps {
  editMode: boolean
  scaleFactor: number
  updateWidget: (arg0: string, arg1: InnerWidgetPatchBody) => void
  widget: TCoreWidget
}

const WidgetHeader = (props: WidgetHeaderProps) => {
  const { editMode, scaleFactor, updateWidget, widget } = props

  // These widget types handle their own header or don't have one
  if (
    widget.type === WidgetType.TEXT ||
    widget.type === WidgetType.COMMENT ||
    widget.type === WidgetType.IMAGE
  ) {
    return null
  }

  const showTitle = widget.show_title
  const showSubtitle = widget.show_subtitle

  return (
    <Box
      sx={{
        position: 'relative',
        height: 'auto',
        pb: showTitle ? 1 * scaleFactor : undefined
      }}
    >
      {showTitle || showSubtitle ? (
        <Box sx={{ flex: 1, minWidth: 0, width: '100%' }}>
          {showTitle ? (
            <Box
              sx={{
                fontSize: 20 * scaleFactor,
                flex: 1,
                minWidth: 0,
                width: '100%',
                display: 'flex',
                color: 'text.primary',
                alignItems: 'center'
              }}
            >
              {widget.tooltip !== '' ? (
                <Tooltip title={widget.tooltip}>
                  <Icon fontSize="inherit" name={'Info'} sx={{ mr: 0.5 }} />
                </Tooltip>
              ) : null}
              <EditableText
                disabled={!editMode}
                onSubmit={(value) => {
                  updateWidget(widget.id, { title: value })
                }}
                scaleFactor={scaleFactor}
                value={widget.title}
                variant="title"
              />
            </Box>
          ) : null}
          {showSubtitle ? (
            <Box sx={{ mt: 0.5 * scaleFactor }}>
              <EditableText
                disabled={!editMode}
                onSubmit={(value) => {
                  updateWidget(widget.id, { subtitle: value })
                }}
                scaleFactor={scaleFactor}
                value={widget.subtitle}
                variant="subtitle"
              />
            </Box>
          ) : null}
        </Box>
      ) : null}
    </Box>
  )
}

export default WidgetHeader
